// import 'sharer.js';
// eslint-disable-next-line
import Dropdown from 'bootstrap/js/dist/dropdown';
import {
  Swiper,
  Navigation,
  Thumbs,
  Autoplay,
  EffectFade,
} from 'swiper/swiper.esm';
// import CookieConsent from 'cookieconsent';

const Rellax = require('rellax');

export default function uiComponentsInit() {
  const banner = $('.banner.fixed-top');
  const halfViewportHeight =
    banner.outerHeight() + (window.innerHeight - banner.outerHeight()) / 2;

  Swiper.use([Navigation, Thumbs, Autoplay, EffectFade]);
  // window.Sharer.init();

  window.cookieconsent.initialise({
    palette: {
      popup: {
        background: '#ffffff',
      },
      button: {
        background: '#0186d1',
      },
    },
    content: {
      href: cookieConsent.href,
      message: cookieConsent.disclaimer,
      dismiss: cookieConsent.allow,
      link: cookieConsent.learn,
    },
    position: 'bottom-left',
  });

  $('.wp-video-shortcode[autoplay]').trigger('play');
  // eslint-disable-next-line no-unused-vars
  const rellax = new Rellax('.rellax');

  $('.card').hover(
    function () {
      $(this)
        .removeClass('shadow-sm')
        .addClass('shadow')
        .css('cursor', 'pointer');
    },
    function () {
      $(this).removeClass('shadow').addClass('shadow-sm');
    }
  );

  // eslint-disable-next-line func-names
  $('.btn-spinner').on('click', function () {
    const $this = $(this);
    // console.log($(this));
    $this
      .addClass('loading')
      .append(
        "<span class='spinner-border' role='status' aria-hidden='true'></span>"
      );

    // eslint-disable-next-line func-names
    setTimeout(() => {
      $this.removeClass('loading');
      $('.spinner-border').remove();
    }, 4000);
  });

  $('.wpcf7-submit').on('click', function () {
    $(this).addClass('loading');
    $(this)
      .closest('.wpcf7')
      .find('.wpcf7-response-output')
      .hide(0, function () {
        $(this).removeClass(
          'alert alert-danger alert-warning alert-success mt-2'
        );
      });
  });

  $('.wpcf7').on('wpcf7submit', function () {
    $(this).find('.wpcf7-response-output').fadeIn();
    $(this).find('.wpcf7-submit').removeClass('loading');
  });

  $('.wpcf7').on('wpcf7submit', function () {
    $(this)
      .find('.wpcf7-response-output')
      .not('.alert-warning')
      .not('.alert-danger')
      .addClass('alert alert-success mt-2');
  });

  /* Validation Events for changing response CSS classes */

  document.addEventListener(
    'wpcf7invalid',
    (event) => {
      $(event.target)
        .find('.wpcf7-response-output')
        .fadeIn()
        .not('.alert-warning')
        .not('.alert-success')
        .addClass('alert alert-danger mt-2');
      event.detail.apiResponse.invalid_fields.forEach((invalidField) => {
        const invalidInputs = event.target.querySelector(
          `${invalidField.into} input`
        );
        invalidInputs.classList.add('is-invalid');
      });

      // show first failing field
      const firstInvalidField = $(
        event.detail.apiResponse.invalid_fields[0].into
      );

      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            firstInvalidField.offset().top -
            halfViewportHeight +
            firstInvalidField.height(),
        },
        100
      );
    },
    false
  );
  document.addEventListener(
    'wpcf7spam',
    (event) => {
      $(event.target)
        .find('.wpcf7-response-output')
        .not('.alert-danger')
        .not('.alert-success')
        .addClass('alert alert-warning mt-2');
    },
    false
  );
  document.addEventListener(
    'wpcf7mailfailed',
    (event) => {
      $(event.target)
        .find('.wpcf7-response-output')
        .fadeIn()
        .not('.alert-danger')
        .not('.alert-success')
        .addClass('alert alert-warning mt-2');

      // show first failing field
      $([document.documentElement, document.body]).animate(
        {
          scrollTop:
            $(event.detail.apiResponse.invalid_fields[0].into).offset().top -
            halfViewportHeight,
        },
        100
      );
    },
    false
  );
  document.addEventListener(
    'wpcf7mailsent',
    (event) => {
      $(event.target)
        .find('.wpcf7-response-output')
        .fadeIn()
        .not('.alert-danger')
        .not('.alert-warning')
        .addClass('alert alert-success mt-2');
      // show success message in the middle of viewport
      const el = event.target.querySelector('.wpcf7-response-output');
      $('html, body').animate(
        {
          scrollTop: el.offsetTop - halfViewportHeight,
        },
        100
      );
    },
    false
  );

  const swiperCommons = {
    resistanceRatio: 0,
    speed: 200,
    loop: false,
    observeParents: true,
    observer: true,
    autoplay: {
      delay: 7000,
      pauseOnMouseEnter: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 0px
      0: {
        slidesPerView: 1,
      },
      // when window width is >= 576px
      768: {
        slidesPerView: 1,
      },
      // when window width is >= 768px
      901: {
        slidesPerView: 'auto',
      },
      // when window width is >= 991px
      1201: {
        slidesPerView: 'auto',
      },
      // when window width is >= 1201px
      1501: {
        slidesPerView: 'auto',
      },
    },
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
  };

  // eslint-disable-next-line no-unused-vars
  const swiperThumbs = new Swiper('.swiper-machine-thumbnails', {
    ...swiperCommons,
    ...{
      slidesPerView: 4,
      spaceBetween: 10,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: false,
      grabCursor: true,
    },
  });

  // eslint-disable-next-line no-unused-vars
  const swiperPosts = new Swiper('.swiper-machine-container', {
    ...swiperCommons,
    ...{
      thumbs: {
        swiper: swiperThumbs,
      },
    },
  });

  // eslint-disable-next-line no-unused-vars
  const swiperFront = new Swiper('.swiper-front-page-container', {
    ...swiperCommons,
    ...{
      allowTouchMove: false,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: true,
      speed: 600,
      on: {
        slideChangeTransitionStart() {
          const activeSlideVideo = document.querySelector(
            '.swiper-slide-active video'
          );
          if (activeSlideVideo) {
            activeSlideVideo.currentTime = 0;
            activeSlideVideo.play();
          }
        },
        afterInit() {
          const activeSlideVideo = document.querySelector(
            '.swiper-slide-active video'
          );
          if (activeSlideVideo) {
            activeSlideVideo.currentTime = 0;
            activeSlideVideo.play();
          }
        },
      },
    },
  });
}
